import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "metadata"
}
const _hoisted_2 = {
  key: 1,
  class: "description"
}


import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
} from "@ionic/vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import PreviewCardSkeleton from "@/components/Skeletons/PreviewCardSkeleton/PreviewCardSkeleton.vue";
interface Props {
  id: string;
  title: string;
  buttonText: string;
  isLoading: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewCard',
  props: {
    id: {},
    title: {},
    buttonText: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.isLoading)
    ? (_openBlock(), _createBlock(PreviewCardSkeleton, {
        key: 0,
        "data-test": "card-skeleton"
      }))
    : (_openBlock(), _createBlock(_unref(IonCard), {
        key: 1,
        href: "",
        button: true,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('card-clicked', __props.id)), ["prevent"])),
        "data-test": "preview-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              (_ctx.$slots.metadata)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "metadata")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$slots.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "description")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }),
          _createVNode(AppButton, {
            class: "button",
            size: "small",
            type: "tertiary",
            label: _ctx.$t(__props.buttonText),
            disabled: false,
            "aria-hidden": "true",
            "data-test": "button",
            tabindex: "-1"
          }, null, 8, ["label"])
        ]),
        _: 3
      }))
}
}

})